/**
 * @file 飞桨AI For Science共创计划
 * @author v_duzhengqiang
 */
import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';

import CoreStrengths from './components/coreStrengths/CoreStrengths';
import FluidMechanics from './components/fluidMechanics/FluidMechanics';
import MolecularDynamics from './components/molecularDynamics/MolecularDynamics';
import NeedToContact from './components/needToContact/NeedToContact';
import Partners from './components/partners/Partners';
import ScienceBanner from './components/scienceBanner/ScienceBanner';



import useScienceHooks from './ScienceHook';


const Science: React.FC = () => {

    const {
        data
    } = useScienceHooks();

    return (
        <div>
            <Header />
            <div className="science">
                {/* banner */}
                <ScienceBanner {...data.scienceBanner}/>
                {/*核心优势 */}
                <CoreStrengths {...data.coreStrengths}/>
                 {/* 计算流体力学 */}
                <FluidMechanics {...data.fluidMechanics}/>
                {/* 分子动力学 */}
                <MolecularDynamics {...data.molecularDynamics}/>
                {/* 合作伙伴 */}
                <Partners {...data.partners}/>
                {/* 底部需求联系 */}
                <NeedToContact {...data.needToContact}/>
            </div>

            <Footer />
        </div>
    );
};

export default React.memo(Science);
